/* import __COLOCATED_TEMPLATE__ from './index.hbs'; */
import Component from '@glimmer/component';
import { action } from '@ember/object';
import { scheduleOnce } from '@ember/runloop';
import WarehouseSyncModel from 'cio/models/warehouse-sync';
import REGIONS from 'cio/utils/integrations/aws-regions';
import FormValidations from 'cio/utils/form-validations';

interface WarehouseSyncBucketConfigurationS3Args {
  model: WarehouseSyncModel;
  validations: FormValidations;
}

export default class WarehouseSyncBucketConfigurationS3 extends Component<WarehouseSyncBucketConfigurationS3Args> {
  readonly regions = REGIONS;
  readonly defaultBucketName = 'my-bucket';
  readonly defaultBucketPath = 'my-path';

  get s3Path(): string {
    let { s3Config } = this.args.model;

    if (s3Config.bucketName || s3Config.bucketPath) {
      return `${s3Config.bucketName ?? ''}/${s3Config.bucketPath ?? ''}`;
    }

    return `${this.defaultBucketName}/${this.defaultBucketPath}`;
  }

  get s3Url(): string {
    return `https://s3.console.aws.amazon.com/s3/buckets/${this.s3Path}`;
  }

  @action
  onUpdateInput(key: string, value: string): void {
    this.args.model.s3Config = { ...this.args.model.s3Config, [key]: value };
    this.args.validations.validateAttribute(key);
  }

  @action
  onRegionSelect(region: { value: string }): void {
    this.args.model.s3Config = { ...this.args.model.s3Config, region: region.value };
    scheduleOnce('afterRender', this, () => {
      this.args.validations.validateAttribute('region');
    });
  }
}
